import axios from "axios";

const baseUrlDev = "https://api-dhct-int-app.carenow.healthcare/dhct";

export const apiAxios = axios.create({ baseURL: baseUrlDev });

export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://retail-api-one-int-wrapper-app.carenow.healthcare");

export const cndWrapperURL = (url = "") =>
  new URL(url, "https://vc.cloudcayr.careplix.com");

export const cndURL = (url = "") =>
  new URL(url, "https://api-int-prod.carenowdoc.com");
